import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { brl } from "@/lib/api";
import { AlertTriangle, Bell, X } from "lucide-react";

/**
 * Floating card that polls /api/notifications/payables and surfaces
 * overdue + due-soon payables on top of the main content.
 */
export default function PayableAlert() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const load = () => api.get("/notifications/payables").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60_000);
    return () => clearInterval(t);
  }, []);

  if (!data || dismissed) return null;
  const nOverdue = data.overdue?.length || 0;
  const nSoon = data.due_soon?.length || 0;
  if (nOverdue === 0 && nSoon === 0) return null;

  const tone = nOverdue > 0 ? "bg-rose-50 border-rose-200 text-rose-900" : "bg-amber-50 border-amber-200 text-amber-900";

  return (
    <div className={"mb-4 border rounded-lg px-4 py-3 flex items-start gap-3 " + tone} data-testid="payable-alert">
      {nOverdue > 0 ? <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" /> : <Bell className="w-5 h-5 shrink-0 mt-0.5" />}
      <div className="flex-1 text-sm">
        <div className="font-semibold">Lembrete de contas a pagar</div>
        {nOverdue > 0 && (
          <div className="mt-1">
            <b>{nOverdue}</b> conta(s) <b>vencida(s)</b> — total <span className="kpi-num">{brl(data.overdue_total)}</span>
          </div>
        )}
        {nSoon > 0 && (
          <div className="mt-1">
            <b>{nSoon}</b> conta(s) vencem nos próximos 3 dias — total <span className="kpi-num">{brl(data.due_soon_total)}</span>
          </div>
        )}
        <button className="mt-2 underline text-xs font-medium" onClick={() => nav("/contas-a-pagar")} data-testid="goto-payables-btn">
          Ver contas a pagar →
        </button>
      </div>
      <button onClick={() => setDismissed(true)} className="opacity-60 hover:opacity-100" aria-label="Dispensar" data-testid="dismiss-payable-btn">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
